<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold"
        >“Daily or weekly - it’s built into our rhythm.”
      </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This shows a <span class="font-bold"
        >cadence of development and decision-making depth.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      Your team is building reps - not just collecting titles.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Fast Attack crews don’t wait for emergencies to train. They drill
      constantly so clarity becomes instinct.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic"
        >Are we practicing real-world decision scenarios?</span
      >
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Use weekly rhythms to run “what would you do?” exercises to sharpen
      leadership judgment across all levels.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold"
        >“Monthly or quarterly, if there’s time.”
      </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      There’s some structure - but development isn’t driving day-to-day
      readiness.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Readiness isn’t a quarterly review. It’s the ability to respond at speed,
      any day.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Start embedding development into real work.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Ask: <span class="italic"
        >Where can we pause after a decision and reflect as a team?</span
      >
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Turn routine meetings into leadership growth opportunities.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold">“Once or twice a year.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is ceremonial development - not practical or continuous.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Fast Attack teams don’t just train once at launch - they evolve constantly
      to stay sharp.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic"
        >What’s one habit we can introduce monthly to sharpen decision-making?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Create a “lessons from the front” debrief ritual where leaders share wins,
      failures, and how they made the call.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold"
        >“We talk about leadership, but don’t actually build it in.”</span
      >
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a major gap - leadership talk without systems means your team
      isn’t equipped for critical decisions.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a sub, talking about protocols isn’t enough. Crews train for crisis -
      because when the moment hits, hesitation costs lives.
    </p>

    <p class="mt-6 text-sm lg:text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Make it real. Launch a 30-minute monthly readiness session.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Each one focused on a decision your team will likely face - and how to
      prepare for it before it shows up
    </p>
  {/if}
</div>
